import { useEffect, useState } from 'react';
import { doc, getDoc, collection, query, where, getDocs } from 'firebase/firestore';
import { auth, db } from '../firebase';
import { onAuthStateChanged } from 'firebase/auth';

export const useStaffIdentity = () => {
  const [staffId, setStaffId] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribeAuth = onAuthStateChanged(auth, async (user) => {
      if (!user || !user.email) {
        setStaffId(null);
        setLoading(false);
        return;
      }

      setLoading(true);

      try {
        // 1. Resolve from user_identity_map
        const idMapRef = doc(db, 'user_identity_map', user.email);
        const idMapSnap = await getDoc(idMapRef);

        if (idMapSnap.exists()) {
          setStaffId(idMapSnap.data().staffId);
        } else {
          // 2. Fallback to lookup by UID in users collection
          const userDocRef = doc(db, 'users', user.uid);
          const userDocSnap = await getDoc(userDocRef);
          if (userDocSnap.exists()) {
            const userData = userDocSnap.data();
            setStaffId(userData.staffId || null);
          }
        }
      } catch (error) {
        console.error("Error resolving staffId:", error);
      } finally {
        setLoading(false);
      }
    });

    return unsubscribeAuth;
  }, []);

  return { staffId, loading };
};
